module.exports = __webpack_public_path__ + "img/logo.25d6b95d.svg";